import React from 'react'
import { EmailLink } from './EmailLink'
import { useConversationWidgetContext } from './ConversationWidget'

export const EmailThruChatWindow = ({ className }: any) => {
  const { openConversationWidget } = useConversationWidgetContext()
  const onClick = (e) => {
    e?.preventDefault()
    openConversationWidget()
  }

  return <EmailLink className={className} onClick={onClick} />
}
